import { BASE_PATH } from "..";
import type { SveaRequest } from "../../types/request";

export const setupPackageAgreement: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package/setup-agreement`,
	method: "POST",
});

export const fetchPackageAgreement: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/package/agreement`,
	method: "GET",
	headers: {
		"content-type": "application/json",
	},
});

export const fetchPackageSigners: SveaRequest = (applicationId: string) => ({
	url: `${BASE_PATH}/application/${applicationId}/signatories`,
	method: "GET",
});
